import { render, staticRenderFns } from "./ProductPriceArea.vue?vue&type=template&id=1ee54584&scoped=true"
import script from "./ProductPriceArea.vue?vue&type=script&lang=js"
export * from "./ProductPriceArea.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceArea.vue?vue&type=style&index=0&id=1ee54584&prod&scoped=true&lang=css"
import style1 from "./ProductPriceArea.vue?vue&type=style&index=1&id=1ee54584&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee54584",
  null
  
)

export default component.exports